import styles from "../styles/create-custom-voice-filter-button.module.scss";
import Image from "next/image";
import magicStickIcon from "@/assets/icons/magic-stick.svg";
import Link from "next/link";
import React from "react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const CreateCustomVoiceFilterButton = () => {
  const { hideModal } = useGlobalModalContext();
  return (
    <Link
      className={styles.create_voice_button}
      href={"/custom"}
      onClick={hideModal}
    >
      Make your own AI voice
      <Image src={magicStickIcon} alt={""} height={20} />
    </Link>
  );
};

export default CreateCustomVoiceFilterButton;
